function initializeAnchorLinks() {
  const anchorLinkEls = document.querySelectorAll('.anchor-link');
  if (anchorLinkEls) {
    anchorLinkEls.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        try {
          const sectionName = el.getAttribute('href').replace('#', '');
          location.hash = sectionName;
          const sectionEl = document.getElementById(sectionName);
          sectionEl.scrollIntoView({ behavior: 'smooth' });
        } catch (e) {
          console.error(e);
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', initializeAnchorLinks);
